<template>
  <section class="section" id="about" ref="about" >
    <b-container>
      <b-row>
        <div class="frame-out mx-auto">
          <div class="frame-in">
            <div class="content text-left">
              <div class="title-wrapper">
                <span>
                  <h2 class="font-bad font-weight-bold text-center mb-0"> About Me </h2>
                </span>
              </div>
              <p class="mb-4 font-bad text-center">"The only way to master life — like Tetris — is to learn to play with the same self-control at the highest speeds."
              </p>
              <p class="text-justify">
                Software Developer passionate about front-end development. I have formally worked as a software developer for 8 years with programming languages: C#, PHP, JavaScript. Frameworks and other technologies such as: .NET, Vue.js and Vuex, Vuetify, Firebase, Laravel, Bootstrap among other. 
              </p>
              <p class="text-justify">
                I'm currently working as Lead Software Developer, developing mainly front-end area with Vue.js and mentoring backend team with .NET.
                I am also instructor at online platforms such as LinkedIn Learning and impart face to face courses.
              </p>
              <p class="text-justify mb-0">
                I enjoy learning but also sharing, so I also help communities as speaker or organizer:
                WomenTech Maker Ambassador,
                GDG Cancun Co-organizer.
              </p> 
            </div>
          </div>
        </div>
      </b-row>
    </b-container>
  </section>
</template>

<script>
  export default {
  }
</script>

<style scoped>
.aboutme-wrapper{
  max-width: 580px;
}
/* about */
.frame-out{
  position: relative;
}
.frame-out:before, 
.frame-out:after{
    position: absolute;
    width: 60px; 
    height: 60px;
    border-color: #4F4F51; 
    border-style: solid;
    content: ' ';
}
.frame-out:before {
    top: 10px;
    left: 10px;
    border-width: 2px 0 0 2px;
}
.frame-out:after {
    bottom: 10px;
    right: 10px;
    border-width: 2px 0 0 2px;
    transform: rotate(180deg);
}
.frame-in{
  padding: 30px 20px;
  position: relative;
}
.frame-in:before, 
.frame-in:after{
    position: absolute;
    width: 60px; 
    height: 60px;
    border-color: var(--pink-light); 
    border-style: solid;
    content: ' ';
}
.frame-in:before {
    top: 0px;
    left: 20px;
    border-width: 4px 0 0 4px;
    opacity: 1;
}
.frame-in:after {
    bottom: 0px;
    right: 20px;
    border-width: 0 4px 4px 0;
    opacity: 1;
}
.frame-in .content{
  /*padding: 20px;
  max-width: 800px;*/
}

/* ./about */
@media (min-width: 768px){
  .frame-in{
    padding: 40px;
  }
  .frame-in:before {
    opacity: 0;
    transform: translateX(-400px);
    transition: all 0.5s linear;
  }
  .frame-in:hover:before,
  .frame-in:focus:before{
    transform: translateX(0px);
    opacity: 1;
  }
  .frame-in:after {
    opacity: 0;
    transform: translateX(400px);
    transition: all 0.5s linear;
  }
  .frame-in:hover:after,
  .frame-in:focus:after{
    transform: translateX(0px);
    opacity: 1;
  }
}
</style>